var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "161px",
    height: "161px",
    viewBox: "0 0 16 16",
    id: "chat-bubble-16px",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    strokeWidth: 0.00016,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M-20.5,16a.5.5,0,0,1-.354-.146.5.5,0,0,1-.131-.475l.912-3.648A8,8,0,0,1-21,8a8.009,8.009,0,0,1,8-8A8.009,8.009,0,0,1-5,8a8.009,8.009,0,0,1-8,8,7.993,7.993,0,0,1-3.731-.927l-3.648.912A.5.5,0,0,1-20.5,16Zm3.836-1.959a.506.506,0,0,1,.245.064A7.007,7.007,0,0,0-13,15,7.008,7.008,0,0,0-6,8a7.008,7.008,0,0,0-7-7,7.008,7.008,0,0,0-7,7,7.01,7.01,0,0,0,.9,3.419.5.5,0,0,1,.049.366l-.757,3.028,3.028-.757A.5.5,0,0,1-16.664,14.041Z",
    transform: "translate(21)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.a55fe6c54550d2335fd97e3eb39309ee.svg";
export { ForwardRef as ReactComponent };